import React, { ButtonHTMLAttributes } from 'react';

import RightArrowIcon from 'assets/arrow-right-thin.svg';

import styles from './Arrows.module.scss';

const ArrowButton: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ children, ...props }) => (
  <button className={styles.arrowButton} {...props}>
    {children}
    <RightArrowIcon />
  </button>
);

export default ArrowButton;
